import {
  Timestamp,
  addDoc,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { AdminsRef, db, storage } from "../../../../firebase";
import moment from "moment";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";

export const getGAAdmins = async () => {
  try {
    //const queryRef = query(AdminsRef, where("type", "==", "general"));
    const queryRef = query(AdminsRef);
    const response = await getDocs(queryRef);

    return response;
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    // console.error("Error fetching data from Firestore:", error.message);
    return [];
  }
};

export const usersSearch = (array, keyword) => {
  const searchTerm = keyword.toLowerCase();
  return array.filter((value) => {
    return (
      (value.firstName &&
        value.firstName.toLowerCase().match(new RegExp(searchTerm, "g"))) ||
      (value.lastName &&
        value.lastName.toLowerCase().match(new RegExp(searchTerm, "g"))) ||
      (value.userName &&
        value.userName.toLowerCase().match(new RegExp(searchTerm, "g")))
    );
  });
};

export const getFilterGAAdminUsers = async (
  statusFilterOptions,
  roleFilterOptions,
  dateAddedRange,
  lastLogindateRange,
  setLoading,
  handleFilterModalClose
) => {
  const deduplicate = (arr) => {
    const uniqueIds = new Set();
    const uniqueDocs = [];
    arr.forEach((doc) => {
      if (!uniqueIds.has(doc.id)) {
        uniqueIds.add(doc.id);
        uniqueDocs.push(doc);
      }
    });
    console.log("results:", uniqueDocs);
    handleFilterModalClose();
    return uniqueDocs;
  };

  try {
    setLoading(true);

    let results = [];

    const statusOptions =
      statusFilterOptions.length > 0 ? statusFilterOptions : [null];
    const roleOptions =
      roleFilterOptions.length > 0 ? roleFilterOptions : [null];

    for (const status of statusOptions) {
      for (const role of roleOptions) {
        let queries = [];

        if (status !== null) {
          queries.push(where("status", "==", status));
        }

        if (role !== null) {
          queries.push(where("role", "==", role));
        }

        //queries.push(where("type", "==", "general"));

        if (
          dateAddedRange &&
          dateAddedRange.startDate &&
          dateAddedRange.endDate
        ) {
          queries.push(where("createdAt", ">=", dateAddedRange.startDate));
          queries.push(where("createdAt", "<=", dateAddedRange.endDate));
        }

        if (
          lastLogindateRange &&
          lastLogindateRange.startDate &&
          lastLogindateRange.endDate
        ) {
          console.log("last login dates:::", lastLogindateRange)
          queries.push(
            where("lastLoginDate", ">=", lastLogindateRange.startDate)
          );
          queries.push(
            where("lastLoginDate", "<=", lastLogindateRange.endDate)
          );
        }

        if (queries.length > 0) {
          const q = query(AdminsRef, ...queries);
          const querySnapshot = await getDocs(q);

          const fetchDetailsPromises = querySnapshot.docs.map(async (doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          });

          const queryResults = await Promise.all(fetchDetailsPromises);
          results = results.concat(queryResults);
        }
      }
    }

    const uniqueResults = deduplicate(results);
    handleFilterModalClose(); // Assuming it's appropriate to close the modal here
    return uniqueResults;
  } catch (error) {
    console.log("error filtering admins:", error.message);
  } finally {
    setLoading(false);
  }
};

// export const getFilterGAAdminUsers = async (
//   statusFilterOptions,
//   roleFilterOptions,
//   dateAddedFilterOptions,
//   lastLoginDateFilterOptions,
//   setLoading,
//   handleFilterModalClose
// ) => {
//   // Set loading to true at the beginning of the function
//   setLoading(true);
//   const deduplicate = (arr) => {
//     const uniqueIds = new Set();
//     const uniqueDocs = [];
//     arr.forEach((doc) => {
//       if (!uniqueIds.has(doc.id)) {
//         uniqueIds.add(doc.id);
//         uniqueDocs.push(doc);
//       }
//     });
//     console.log("results:", uniqueDocs);
//     handleFilterModalClose();
//     return uniqueDocs;
//   };

//   try {
//     // let resultsData = [];

//     // Start with a query that filters QuickTales by the specific organization
//     let baseQuery = query(AdminsRef, where("type", "==", "general"));

//     // Apply 'Who Can Listen' filters
//     statusFilterOptions.forEach((option) => {
//       baseQuery = query(baseQuery, where("status", "==", option));
//     });

//     // Apply 'QT Status' filters
//     roleFilterOptions.forEach((option) => {
//       baseQuery = query(baseQuery, where("role", "==", option));
//     });

//     // let queries = [
//     //   ...statusFilterOptions.map((option) => where("status", "==", option)),

//     //   ...roleFilterOptions.map((option) => where("role", "==", option)),
//     // ];

//     // Add date added range filter if provided
//     if (dateAddedFilterOptions.length > 0) {
//       const dateRangeString = dateAddedFilterOptions.find((option) =>
//         option.startsWith("Date Added:")
//       );
//       if (dateRangeString) {
//         const dates = dateRangeString.replace("Date Added: ", "").split(" - ");
//         const startDate = moment(dates[0], "MM/DD/YYYY")
//           .startOf("day")
//           .toDate();
//         const endDate = moment(dates[1], "MM/DD/YYYY").endOf("day").toDate();

//         // Add date range conditions to the query
//         // queries.push(where("createdAt", ">=", Timestamp.fromDate(startDate)));
//         // queries.push(where("createdAt", "<=", Timestamp.fromDate(endDate)));
//         baseQuery = query(
//           baseQuery,
//           where("createdAt", ">=", Timestamp.fromDate(startDate))
//         );
//         baseQuery = query(
//           baseQuery,
//           where("createdAt", "<=", Timestamp.fromDate(endDate))
//         );
//       }
//     }

//     // Add date last login range filter if provided
//     if (lastLoginDateFilterOptions.length > 0) {
//       const dateRangeString = lastLoginDateFilterOptions.find((option) =>
//         option.startsWith("Last Login:")
//       );
//       if (dateRangeString) {
//         const dates = dateRangeString.replace("Last Login: ", "").split(" - ");
//         const startDate = moment(dates[0], "MM/DD/YYYY")
//           .startOf("day")
//           .toDate();
//         const endDate = moment(dates[1], "MM/DD/YYYY").endOf("day").toDate();

//         // Add date range conditions to the query
//         // queries.push(
//         //   where("lastLoginDate", ">=", Timestamp.fromDate(startDate))
//         // );
//         // queries.push(where("lastLoginDate", "<=", Timestamp.fromDate(endDate)));
//         baseQuery = query(
//           baseQuery,
//           where("lastLoginDate", ">=", Timestamp.fromDate(startDate))
//         );
//         baseQuery = query(
//           baseQuery,
//           where("lastLoginDate", "<=", Timestamp.fromDate(endDate))
//         );
//       }
//     }

//     // Execute the query
//     // const q = query(AdminsRef, ...queries);
//     // const querySnapshot = await getDocs(q);

//     const querySnapshot = await getDocs(baseQuery);

//     // Convert to map to handle async operations
//     const fetchDetailsPromises = querySnapshot.docs.map(async (doc) => {
//       return {
//         id: doc.id,
//         ...doc.data(),
//       };
//     });

//     // Wait for all fetches to complete
//     const results = await Promise.all(fetchDetailsPromises);

//     const uniqueResults = deduplicate(results);
//     handleFilterModalClose(); // Assuming it's appropriate to close the modal here
//     return uniqueResults;
//   } catch (error) {
//     console.error("Error filtering admins:", error);
//     setLoading(false);
//     return []; // Return an empty array in case of error
//   } finally{ setLoading(false)}
// };

export const uploadAdminImageToStorage = async (file, userId) => {
  const newFilename = uuidv4();
  const storageRef = ref(storage, `admins/${userId}/${newFilename}`);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
};
